import { BookOpenIcon, SquareCheckIcon, BugIcon, EpicIcon, FeatureIcon, RequirementIcon } from '../components/Icons';
import { TYPE_COLORS } from './colors';

export const TYPE_CONFIG = {
  story: { icon: BookOpenIcon, color: TYPE_COLORS.story, label: 'Story' },
  task: { icon: SquareCheckIcon, color: TYPE_COLORS.task, label: 'Task' },
  bug: { icon: BugIcon, color: TYPE_COLORS.bug, label: 'Bug' },
  epic: { icon: EpicIcon, color: TYPE_COLORS.epic, label: 'Epic' },
  feature: { icon: FeatureIcon, color: TYPE_COLORS.feature, label: 'Feature' },
  requirement: { icon: RequirementIcon, color: TYPE_COLORS.requirement, label: 'Requirement' },
};

export const TYPE_OPTIONS = [
  { value: 'story', label: 'Story', dot: TYPE_COLORS.story },
  { value: 'task', label: 'Task', dot: TYPE_COLORS.task },
  { value: 'bug', label: 'Bug', dot: TYPE_COLORS.bug },
  { value: 'epic', label: 'Epic', dot: TYPE_COLORS.epic },
  { value: 'feature', label: 'Feature', dot: TYPE_COLORS.feature },
  { value: 'requirement', label: 'Requirement', dot: TYPE_COLORS.requirement },
];

export const TYPES_SIMPLE = [
  { value: 'story', label: 'Story' },
  { value: 'task', label: 'Task' },
  { value: 'bug', label: 'Bug' },
];

export const HIERARCHY_TYPES_SIMPLE = [
  { value: 'epic', label: 'Epic' },
  { value: 'feature', label: 'Feature' },
  { value: 'requirement', label: 'Requirement' },
  { value: 'story', label: 'Story' },
  { value: 'task', label: 'Task' },
  { value: 'bug', label: 'Bug' },
];

export const HIERARCHY_RULES = {
  epic: ['feature'],
  feature: ['requirement'],
  requirement: ['task', 'bug'],
};

export const CONTAINER_TYPES = ['epic', 'feature', 'requirement'];
